import { computed, ref, Ref } from 'vue';
import { IMultiSelect } from '@studyportals/multiselect/dist/src/interfaces/multiselect.interface';
import { IOption } from '@studyportals/multiselect/dist/src/interfaces/options.interface';
import { Region } from '@studyportals/campaign-management-api-interface';
import store from '@/store';

export default class RegionCode {
	public regionDropdown: Ref<IMultiSelect | null> = ref(null);
	public options: IOption[] = [
		{ label: 'Other', value: Region.OTHER },
		{ label: 'APAC', value: Region.APAC },
		{ label: 'EMEA', value: Region.EMEA },
		{ label: 'NA', value: Region.NA },
		{ label: 'STRP', value: Region.STRP },
		{ label: 'UKI', value: Region.UKI }
	];

	public region = computed((): Region | null => {
		return store.getters.region();
	});

	private isRegionSet = computed((): boolean => {
		return this.region.value !== null;
	});

	public mounted(): void {
		this.prefillRegion();
	}

	public setRegion(option: IOption): void {
		store.mutations.setRegion(option.value as Region);
	}

	private prefillRegion(): void {
		if (!this.regionDropdown.value || !this.isRegionSet.value) {
			return;
		}

		const selectedOption = this.options.find((option) => option.value === this.region.value);
		if (!selectedOption) {
			return;
		}

		this.regionDropdown.value.selectOption(selectedOption);
	}
}
